const uk = {
    9000001: "2023 Різдвяний Кубок",
    9000002: "Чемпіонат SuperEx за контрактом",
    9000003: "виграйте 30,000 USDT у конкурсному призовому фонді",
    9000004: "Кількість учасників",
    9000005: "Розблокований призовий фонд (USDT)",
    9000006: "Кваліфікаційний турнір за обсягом торгів",
    9000007: "Кваліфікаційний турнір за рейтингом прибутковості",
    9000008: "Кваліфікаційний турнір за рейтингом суми прибутку",
    9000009: `Змагання за обсягом торгів, розблокуйте призовий фонд до <span style="color: #ffc72b;">20,000</span> USDT`,
    9000010: "Розблокуйте відповідний призовий фонд відповідно до кількості учасників; чим більше учасників, тим більший призовий фонд, до 20,000 USDT",
    9000011: "Сума призового фонду",
    9000012: "Щоденне оновлення о 10:00 (UTC) під час заходу",
    9000013: "Оцінка нагород",
    9000014: "Загальний обсяг торгівлі ф'ючерсами за період",
    9000015: "Правила нагородження",
    9000016: "Розблокуйте відповідний призовий фонд відповідно до кількості учасників; чим більше учасників, тим більший призовий фонд, до 20,000 USDT",
    9000017: "Сума призового фонду (USDT)",
    9000018: "Рейтинг рентабельності діяльності",
    9000019: "Реєстрація",
    9000020: "Рейтинг за сумою прибутку заходу",
    9000021: "Закінчено",
    9000022: `Переглянути список за прибутковістю, розділити <span style="color: #ffc72b;">{moneyPond}</span> доларів у формі USDT`,
    9000023: `Змагання за рейтингом суми прибутку, розділіть призовий фонд у <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000024: "Рейтинг кумулятивної прибутковості ф'ючерсів",
    9000025: "Загальний ф'ючерсний прибуток",
    9000026: "Не розпочато",
    9000027: "Учасники, що займають перші 50 місць за сумою прибутку, можуть отримати нагороди, можна ознайомитися з правилами нагородження за рейтингом торгів",
    9000028: "50 користувачів з найбільшою прибутковістю можуть отримати винагороду. Щоб отримати винагороду, ви можете прочитати правила винагороди за торговельний рейтинг.",
    9000029: "Рейтинг торговельного обороту заходу",
    9000030: "Реєстрація успішна",
    9000031: "Завантажте програму",
    9000032: "На головну",

    //合约交易积分
    9100001: 'Зберегти бали',
    9100002: 'Отримати Airdrop',
    9100003: 'Обміняти винагороди',
    9100004: 'Баланс балів',
    9100005: 'Деталі',
    9100006: 'Бали за реєстрацію',
    9100007: 'Торгові бали',
    9100008: 'Бали за запрошення',
    9100009: 'Бонусні бали',
    9100010: 'Щасливий розіграш',
    9100011: 'Отримайте бали',
    9100012: 'Правила нарахування балів',
    9100013: 'Інформація про бали',
    9100014: 'Щоб взяти участь у цій події, вам потрібно зареєструватися. Натисніть, щоб зареєструватися',
    9100015: 'Ви торгували {day} днів поспіль і заробили {num} балів',
    9100016: 'Бали, зароблені сьогодні {num}.',
    9100017: 'Призовий фонд у балах',
    9100018: 'Кожен розіграш коштує {point} балів, і за день можна провести не більше {num} розіграшів.',
    9100019: 'Кількість щасливих розіграшів сьогодні',
    9100020: 'Користувач',
    9100021: 'Бали',
    9100022: 'Недостатньо балів на рахунку',
    9100023: 'На вашому рахунку недостатньо балів. Будь ласка, поповніть баланс для участі в розіграші.',
    9100024: 'Кількість розіграшів досягла свого ліміту!',
    9100025: 'Кількість розіграшів на сьогодні вичерпано. Спробуйте завтра.',
    9100026: 'Як отримати бали',
    9100027: `Зареєструйтеся для участі у ф'ючерсній торгівлі, щоб заробляти бали.`,
    9100028: 'Реєстрація успішна',
    9100029: `Ви зареєструвалися для участі в торгівлі ф'ючерсами, щоб заробити бали. Перейдіть до торгівлі, щоб заробити більше балів (ви більше не будете користуватися комісією та винагородою у вигляді кешбеку)`,
    9100030: 'Після скасування реєстрації ви більше не будете отримувати бали. Ви впевнені, що хочете скасувати реєстрацію?',
    9100031: 'Центр активності торгових балів',
    9100032: 'Отримайте бали',
    9100033: 'Щоб взяти участь у цій події, вам потрібно зареєструватися. Натисніть, щоб зареєструватися',
    9100034: `Ви можете отримувати бали безперервно, торгуючи ф'ючерсами`,
    9100035: `Користувачі можуть заробляти бали за всі операції з ф'ючерсами`,
    9100036: 'Бали в таблиці лідерів',
    9100037: `П'ять кращих користувачів у щоденному рейтингу отримають додаткові бонусні бали`,
    9100038: 'Запрошувач та запрошені користувачі отримають бонусні бали.',
    9100039: '{guy} Вже виграв <span style="color:#D9A31A"> {num} балів!</span>',
    9100040: 'Спробуйте Lucky Draw зараз!',
    9100041: 'Вітаємо з отриманням',
    9100042: 'Всі типи',
    9100043: 'Залишитися на цій сторінці',
    9100044: 'Зареєструйтесь для участі',
    9100045: 'Продовжити торгівлю',
    9100046: 'На даний момент немає проходячих подій. Будь ласка, следуйте за оновленнями...',
    9100047: 'отримуйте аірдропи та обмінюйте їх на токени SCS',
    9100048: '',
    9100049: '',

    9100050: 'Дати',
    9100051: 'Виберіть дату початку',
    9100052: 'Виберіть дату завершення',
    9100053: 'до',
    9100054: 'Тип',

    9100055: 'Зароблені бали = обсяг торгів * 1% (складність буде додатково коригуватися в міру збільшення загального обсягу торгів на платформі)',
    9100056: 'Наприклад: користувач використовує позицію з маржею 100 USDT*100X=10000 USDT',
    9100057: 'Тоді для отримання 100 балів потрібно лише депозит у розмірі 100 USDT',
    9100058: 'Торгові бали - це єдиний спосіб отримати токен платформи SCS',
    9100059: 'Додаткові бонусні бали = загальна кількість балів за день * рейтинговий коефіцієнт винагороди',
    9100060: 'Ранг',
    9100061: '1 місце',
    9100062: '2 місце',
    9100063: '3 місце',
    9100064: '4 місце',
    9100065: '5 місце',
    9100066: 'Запрошувач та запрошені користувачі отримають бонусні бали.',
    9100067: 'Коефіцієнт рівня',
    9100068: 'Формула розрахунку: отримані бали рефералів = бали, отримані запрошеним * коефіцієнт рівня',
    9100069: 'Коефіцієнт рівня буде коригуватися відповідно до фактичної ситуації',
    9100070: 'Наприклад: Користувач B бере участь в активності, що приносить бали, його запрошує Користувач A, а кількість запрошень від Користувача A досягла 3-го рівня. Користувач Б накопичив балів = 360 000;',
    9100071: 'Тоді кумулятивна кількість балів заохочення, яку може отримати користувач А = 360000*30% = 108 000',
    9100072: 'Коефіцієнт винагороди',
    9100073: '1 Торгуючих користувачів',
    9100074: 'Обсяг торгів досягає 5 мільйонів',
    9100075: 'Обсяг торгів досягає 20 мільйонів ',

    9100076: 'Переказ',

    //热币
    9100080: 'Завершено',
    9100081: 'Натисніть «Приєднатися зараз», щоб виграти винагороди',
    9100082: 'Переглянути правила',
    9100083: 'Приєднуйся зараз',
    9100084: 'Діяльність',
    9100088: 'Торгівля',
    9100089: 'депозит',
    9100090: 'Ви вже зареєстровані.',

    9100091: 'Ця подія вже завершилася, з нетерпінням чекайте наступної події!',
    9100092: `Подія ще не почалася, будь ласка, залишайтесь на зв'язку.`,
    9100093: '',
    9100094: '',

    //api key
    9100105: 'Створити API ключ',
    9100106: 'Переглянути документацію API',
    9100107: 'Інтегрована торгова система',
    9100108: 'Створити/управляти API ключем',
    9100109: 'Розгортання API',
    9100110: 'Торгівля і запити',
    9100111: 'Провідна платформа цифрових активів',
    9100112: 'Широкий спектр послуг з торгівлі цифровими активами і управління активами, щоб задовольнити різноманітні торгові потреби.',
    9100113: 'Забезпечення кращих послуг',
    9100114: 'Більш вигідні торгові комісії, вищі торгові суми, більш гнучкі функції управління рахунком і т.д.',
    9100115: 'Вибір мільйонів користувачів',
    9100116: 'Забезпечення безпечного торгового середовища, надання професійної підтримки клієнтів, допомога вам стабільно просуватися в світі цифрових активів.',
    9100117: 'Як створити API ключ в SuperEx?',
    9100118: 'Де я можу переглянути документацію API SuperEx?',
    9100119: 'Що робити, якщо виникають проблеми з торгівлею в SuperEx?',
    9100120: 'Як використовувати API SuperEx?',
    9100121: 'Доступ до API SuperEx для швидшої і плавнішої торгівлі',
    9100122: `У стані входу в систему наведіть курсор на аватар - 'Управління API' і натисніть 'Створити API ключ', щоб створити ваш API ключ в SuperEx. Примітка: якщо ви не увійшли в систему, спочатку вам потрібно увійти до свого облікового запису SuperEx.
Ви також можете створити свій API ключ з посилання 'APIs' у нижній навігаційній панелі.`,
    9100123: 'Ви можете натиснути <a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com/en/quickStart.html">Документація API</a>, щоб переглянути документацію API SuperEx.',
    9100124: `Якщо ви зіткнетеся з будь-якими проблемами або маєте пропозиції під час використання, ви можете зв'язатися з нами наступними способами: <br>Зверніться до служби підтримки через "Центр допомоги" на офіційному сайті або відправивши листа на support@superex.com.`,
    9100125: `Щоб використовувати API SuperEx, вам спершу потрібно:<br>
Зареєструватися і увійти до свого облікового запису SuperEx.<br>
Створити API ключ, який згенерує для вас access_key і secret_key.<br>
Використовуйте цей access_key і secret_key для підпису ваших запитів.<br>
Залежно від ваших потреб, ви можете використовувати різні API, які надає SuperEx, такі як API ринкових даних, торговий API і API облікових записів. Переконайтеся, що кожен запит відповідає інструкціям у документації API, з належними HTTP заголовками і підписами.`,
    9100126: 'Дія',
    9100127: 'Ukrainian Translation: Створити новий API ключ',
    9100128: 'Назва API ключа',
    9100129: 'Будь ласка, введіть назву API ключа',
    9100130: 'Дозволи (Множинний вибір)',
    9100131: 'Читання',
    9100132: 'Торгівля',
    9100133: `Список дозволених IP адрес (необов'язково)`,
    9100134: `Ви можете зв'язати до 10 IP адрес з кожним API ключем, розділеними комами.`,
    9100135: 'Я прочитав(-ла) і погоджуюсь з',
    9100136: 'Я прочитав і згоден з Повідомленням про ризики користувача API',
    9100137: 'Створити',
    9100138: 'SuperEx надає вам потужний API, який дозволяє використовувати такі послуги, як запити на ринок і автоматична торгівля. Дивіться, як його використовувати, переглядаючи <a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com/en/quickStart.html">Документацію API</a>.',
    9100139: 'Кожен рахунок може створити до 10 API ключів.',
    9100140: `API ключі, які не зв'язані з IP, автоматично закінчуються через 90 днів. Якщо ви плануєте використовувати їх довгостроково, ви можете продовжити свій API ключ у розділі 'Мій API ключ' — 'Дія' — 'Продовжити', продовжуючи термін дії ще на 90 днів. API ключі, пов'язані з IP, не мають обмежень щодо терміну дії.`,
    9100141: 'Мій API ключ',
    9100142: 'Дозволи',
    9100143: 'IP адреса',
    9100144: 'Оновити',
    9100145: 'Для створення API ключа необхідно внести будь-яку суму на ваш спотовий гаманець для активації облікового запису',
    9100146: 'Підтвердіть продовження поточного API ключа',
    9100147: 'Не розкривайте свій Access Key і Secret Key, щоб уникнути втрати активів.',
    9100148: `З міркувань безпеки рекомендується зв'язувати API ключі з конкретними IP адресами. До одного API ключа можна зв'язати максимум 20 IP адрес або IP сегментів. Ви можете ввести одну IP адресу або кілька адрес безпосередньо і розділити різні адреси комою. Наприклад: 192.168.1.1,192.168.1.2`,
    9100149: `Після успішного продовження дата закінчення буде перерахована. Якщо ви використовуєте API ключ на довгий термін, рекомендується зв'язати IP адресу. Прив'язані API ключі не закінчуються і також більш безпечні.`,
    9100150: 'Підтвердити видалення поточного API ключа?',
    9100151: 'Ви повинні зрозуміти наступні ризики:',
    9100152: `Ваш API ключ тісно пов'язаний з безпекою вашого рахунку. Будь-хто, хто знає ваш API ключ, потенційно може контролювати активи вашого рахунку. Тому, будь ласка, належним чином захищайте його, не розкривайте ваш API ключ третім особам і не завантажуйте його на сторонні веб-сайти або форуми.`,
    9100153: 'Якщо ваш API ключ витече з особистих причин, включаючи, але не обмежуючись, проблеми безпеки активів і економічні втрати, ви несете всю відповідальність, що виникає внаслідок цього, і ми не будемо нести жодної відповідальності.',
    9100154: 'Попередження про ризики',
    9100155: 'Я усвідомлюю і готовий(-а) взяти на себе ризик.',
    9100156: 'Збережено',
    9100157: 'Дозволи',
    9100158: 'Секретний ключ відображається лише один раз і не може бути відновлений у разі втрати, будь ласка, зберігайте його в безпеці.',
    9100159: 'Не розкривайте свій Access Key і Secret Key, щоб уникнути втрати активів.',
    9100160: 'Якщо ви забули свій Secret Key, будь ласка, видаліть цю пару ключів і подайте заявку на нову.',
    9100161: 'Ми пропонуємо потужні API, щоб допомогти вам ефективно інтегрувати торгові функції в ваші додатки. API поділені на облікові записи, торгівлю і ринкові дані, дозволяючи вам налаштувати необхідні дозволи і реалізувати автоматизовану торгівлю через API.',
    9100162: 'Час лістингу',
    9100163: 'Ukrainian Translation: Створити новий API ключ',
    9100164: 'Редагувати',
    9100165: 'Дата погашення',
    9100166: 'Видалити',
    9100167: 'Успішно створено',
    9100168: 'Підказки',
    9100169: 'Гаразд',
    9100170: 'Повідомлення про ризик користувача API',
    9100171: 'Неправильний формат IP адреси',
    9100172: '',
    //自由区二维码分享页面
    91000951: 'Spot Meme - криптосвіт користувачів, від користувачів, для користувачів',
    91000961: 'Відкрити додаток',
    //自由区二维码分享页面
    9100095: 'SuperEx Free Market - криптосвіт користувачів, від користувачів, для користувачів',
    9100096: 'Відкрити додаток',
    9100097: '',
    9100098: '',

    //代理商
    101738:'Станьте агентом SuperEx і отримуйте високі комісійні!',
    101739:'Запрошуйте своїх друзів торгувати з SuperEx і отримуйте 50% комісії. Почніть заробляти комісійні після того, як ваші реферали укладуть торгові контракти.',
    101740:'Стати агентом',
    101741:'Як я можу отримувати комісійні?',
    101742:'Подайте заявку, щоб стати агентом',
    101743:'Якщо у вас є спільнота, підписники в ЗМІ та інші ресурси, ви можете подати заявку на отримання статусу агента, і після успішного розгляду ви зможете підвищити свій статус до агента.',
    101744:'Рекламуйте SuperEx',
    101745:'Поділіться своїм запрошувальним посиланням зі своєю спільнотою, підписниками або іншими каналами для рекламного впливу',
    101746:'Отримати комісію',
    101747:'Ви можете заробляти комісійні, коли нові користувачі реєструються і торгують за вашим посиланням-запрошенням.',
    101748:'Скільки комісійних я можу заробити?',
    101749:'Коли ви запрошуєте користувачів торгувати з SuperEx, ви отримуєте 20% від комісії вашого друга в якості бонусу за запрошення.',
    101750:'Якщо ви станете агентом SuperEx, ви також отримаєте 50% агентської винагороди. ',
    101751:'Чому варто стати брокером SuperEx?',
    101752:'Висока комісія',
    101753:'50% знижка на комісію',
    101754:'Підтримка трафіку користувачів',
    101755:'Професійна підтримка трафіку, легкий доступ до доходу',
    101756:'Підтримка брендингу',
    101757:'Глобальні офлайн-заходи з індивідуальною подарунковою периферією',
    101758:'Глобальні офлайн-заходи',
    101759:'Глобальна офлайн-зустріч фанатів SuperEx, найкращі зустрічі галузі та всебічна підтримка для кожного агента, щоб допомогти їм збільшити свої прибутки!',
    101760:'Відгук не прийнято',
    101761:'Агенти',
    101762:'Керування каналами',
    101763:'Створити канал',
    101764:'Афілійовані канали',
    101765:'Метод просування',
    101766:'Назва каналу',
    101767:'Час створення',
    101768:'Редагувати',
    101769:'Фьючерсний коефіцієнт знижки',
    101770:'Спотовий коефіцієнт знижки',
    101771:'Управління просуванням',
    101772:'Код запрошення',
    101773:'Код запрошення',
    101774:'Кількість створених реф. посилань, що залишилися',
    101775:'Друзі',
    101776:'Код запрошення агента',
    101777:'Кількість рефералів агента',
    101778:'Регулярні коди запрошень',
    101779:'Регулярна кількість рефералів',
    101780:'Посилання для запрошення',
    101781:'Звичайні канали',
    101782:'Інформаційне табло',
    101783:'Депозити',
    101784:'Сума транзакції',
    101785:'Комісія',
    101786:'Код запрошення',
    101787:'Відносини з мобільним запрошенням',
    101788:'Звіти за контрактами',
    101789:'Спот-звіти',
    101790:'Транзакції',
    101791:'Розрахунковий центр',
    101792:'Розрахунок за контрактом',
    101793:'Спот-розрахунок',
    101794:'Орієнтовна комісія',
    101795:'Запис про зняття коштів',
    101796:'Переглянути активи',
    101797:'Сума зняття',
    101798:'Накопичена комісія',
    101799:'Поточна кількість токенів не відповідає сумі виведення. Ви можете запросити більше користувачів до торгівлі, щоб отримати бонусні гроші.',
    101800:'Огляд даних контракту',
    101801:'Огляд спот-даних',
    101802:'Деталі контракту',
    101803:'Детальна інформація про спот',
    101804:'Всі напрямки',
    101805:'Орієнтовна комісія агента',
    101806:'Орієнтовна комісія користувача',
    101807:'Час транзакції',
    101808:'Для отримання детальних правил, будь ласка, ознайомтеся з анонсом SuperEx.',
    101809:'Форма заявки на участь в агентській програмі',
    101810:'Ваша мова',
    101811:'В якій країні ви перебуваєте? (Приклад: Іран)',
    101812:'Яка ваша основна платформа/канал?',
    101813:'Скільки у вас підписників/фанів/користувачів на вашій платформі/соціальних мережах/веб-сайті?',
    101814:'Введіть посилання на вашу основну платформу/канал (введіть повну URL-адресу)',
    101815:'Інші соціальні канали/посилання на веб-сайти (введіть повну URL-адресу)',
    101816:`Ваше ім'я`,
    101817:`Заповніть канали соціальних мереж для швидкого зв'язку з вами (наприклад, Telegram id @xxx)`,
    101818:'Звідки ви дізналися про агентську програму?',
    101819:'Друг',
    101820:'Додаткова інформація, якою ви можете поділитися з нами, наприклад, про себе та короткий опис вашого каналу',
    101821:'Чудово!',
    101822:'Ви успішно заповнили заявку на отримання статусу агента SuperEx. Після проходження перевірки ми повідомимо вам по електронній пошті.',
    101823:'Тривалість строку не може перевищувати 3 місяців',
    101824:'Успіх',
    101825:'Всі зняття коштів',
    101826:'Виведено',
    101827:'Поточна кількість токенів не відповідає сумі виведення. Ви можете запросити більше користувачів до торгівлі, щоб отримати бонусні гроші.',
    101828:'Керування користувачами',
    101829:'Ідентифікатор користувача',
    101830:`Коефіцієнт ф'ючерсної комісії`,
    101831:'Спот коефіцієнт винагороди',
    101832:'Час реєстрації',
    101833:'Деталі транзакції',
    101834:'Купити довго',
    101835:'Продати Коротко',
    101836:'Продати довгий',
    101837:'Купити короткий',
    101838:'Час зняття коштів',
    101839:'Валюта зняття',
    101840:'Кількість виведень',
    101841:'Комісія',
    101842:'Сума до зняття',
    101843:'Виведення коштів',
    101844:'Спільнота',
    101845:'Електронна пошта (ця електронна пошта буде використовуватися для отримання інформації про агента, будь ласка, перевірте спам, якщо повідомлення про підтвердження не буде знайдено)',
    101846:'Код верифікації',
    101847:'Наберіться терпіння, поки ми розглядаємо вашу заявку. Ми повідомимо вам, коли вона буде схвалена по електронній пошті.',
    101848:'Вибачте, ваша заявка на отримання статусу агента не була схвалена',
    101849:'Подайте заявку повторно',
    101850:'Огляд даних',
    101851:'Контрактна комісійна ставка для агентів',
    101852:'Агенти за спотовою комісійною ставкою',
    101853:'Ви були дискваліфіковані як агент, якщо у вас виникли питання, будь ласка, зверніться до адміністратора',
    101854:'За весь час',
    101855:'Вчора',
    101856:'Цього місяця',
    101857:'Минулий місяць',
    101858:'Кількість трейдерів',
    101859:'Загальний депозит',
    101860:'Виберіть код запрошення',
    101861:'Валовий заробіток',
    101862:`Комісія за ф'ючерси`,
    101863:'Комісія за спот',
    101864:'На розгляді',
    101865:'Виведено',
    101866:'Буде розблоковано',
    101867:'*Комісійні потрібно виводити на мій спот-рахунок, щоб їх можна було використати.',
    101868:'Підтвердити виведення коштів',
    101869:'Ви впевнені, що хочете вивести всі токени на свій спот-рахунок?',
    101870:'Поточна кількість токенів не відповідає сумі виведення. Ви можете запросити більше користувачів до торгівлі, щоб отримати бонусні гроші.',
    101871:'Розблоковано',
    101872:'Повернуто',
    101873:'Кваліфікацію агента скасовано',
    101874:'Ви вже є агентом',
    101875:'Огляд даних каналу',
    101876:'Дані користувача',
    101877:`На хмарний гаманець Ф'ючерсний рахунок`,
    101878:'На спот-рахунок у хмарному гаманці',
    101879:'Деталі спот-торгівлі',
    101880:`Деталі торгівлі ф'ючерсами`,
    101881:`Розрахунковий центр ф'ючерсів`,
    101882:'Спотовий розрахунковий центр',
    101883:'Звіт про ефективність',
    101884:'Оберіть мову',
    101885:'Введіть відповідь',
    101886:'Виберіть назву каналу',
    101887:'Зняття комісії',
    101888:'Введіть назву каналу',
    101889:'Виберіть метод просування',
    101890:'Введіть примітки',
    101891:'Доступні для виведення кошти',
    101892:'Підтвердіть виведення',
    101893:`Встановити користувачеві коефіцієнт ф'ючерсної знижки`,
    101894:'Встановити користувачеві коефіцієнт повернення коштів за спот',
    101895:`Звіт про результати торгівлі ф'ючерсами`,
    101896:'Звіт про результати торгівлі спотами',
    101897:'Конвертація (USDT)',
    101898:'Withdrawal to Cloud Wallet',
    101899:'Are you sure you want to withdraw all your spot commissions to your cloud wallet?',
    101900:'Переглянути кошти',
    101901:'Всі валюти',
    101902:'Не виведено',
    101903:'Загальна комісія',
    101904: "Виберіть країну або регіон",
    101905: "Введіть код підтвердження",
    101906: "Агентська система",
    101907: "Дякуємо, що відгукнулися.",
    101908: "Ваша заявка надіслана. Зазвичай ми розглядаємо вашу інформацію протягом 2-3 робочих днів, і ваша комісія почне діяти після проходження перевірки!",
    //代理商拉新
    92000000:'Зворотний відлік',
    92000001:'Спосіб участі',
    92000002:'Вам потрібно переконатися, що обліковий запис, який виконує завдання, збігається з вашим зареєстрованим/увійшов обліковим записом на поточній сторінці, щоб мати шанс отримати винагороду.',
    92000003:'Очікування перевірки завдання',
    92000004:'Зареєструйтеся на SuperEx за запрошенням від <span style="color:#000922;font-weight:500;">{brokerName}</span>, щоб розблокувати обмежені вітальні бонуси!',
    92000005:'Почнеться з {time}',
    92000006:'Завершити до {time}',
    92000007:'Перевірка завершення завдання може зайняти до 7 робочих днів, будь ласка, будьте терплячі.',
    92000008:'Близько 7 днів після завершення заходу',
    92000009:'Після перевірки завдання нагорода буде перерахована на рахунок протягом 7 робочих днів після завершення заходу.',
    92000010:'Зареєструйтесь, використовуючи посилання-запрошення <span style="color:#000922;font-weight:400;">{brokerName}</span>',
    92000011:'Умови та положення',
    92000012:'Активність у процесі',
    92000013:'Не можна взяти участь у цій події',
    92000014:'Подія завершена',
    92000015:'Отримати винагороду',
    92000016:'Увійти зараз',
    92000017:'Будь ласка, встановіть нікнейм',

    92000018:'Примітки',
    92000019:'Цей пункт є обов’язковим',
    92000020:'Зберегти',
    92000021:'Поділитися постером',
    92000022:'Максимум ',
    92000023:'Редагувати канал',
    92000024:'Створити належний канал',
    92000025:'В цьому каналі немає коду запрошення',
    92000026:'',
    92000027:'',
    92000028:'',
    92000029:'',
    92000030:'',
}
export default uk



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/uk.js